// style
import '../css/style.scss';

// libs
import 'swiper/css/bundle';
import Swiper from "swiper";
import * as SwiperModules from "swiper/modules";
import gsap from "./libs/gsap.min";

Swiper.use(Object.values(SwiperModules));

if (typeof window !== 'undefined') {
  window.gsap = gsap;
}

function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('./../../assets/resource/fonts/', true, /\.(woff|woff2|eot|ttf|otf)$/));

importAll(require.context('./../../components', true, /\.js$/));
importAll(require.context('./../../components', true, /\.scss$/));

importAll(require.context('./../../blocks', true, /\.js$/));
importAll(require.context('./../../blocks', true, /\.scss$/));

importAll(require.context('./utils', true, /\.js$/));
